// CommunityAppGrid - Grid of CommunityAppCards for browse page
// Loading, empty, and infinite-scroll sentinel support
// Admin mode: card click opens CommunityAppCardModal instead of navigating

import React, { useState } from 'react';
import { CommunityAppCard } from './CommunityAppCard';
import { CommunityAppCardModal } from './CommunityAppCardModal';
import './CommunityAppGrid.css';

export function CommunityAppGrid({
  apps = [],
  loading = false,
  emptyMessage = 'No community apps found',
  loadMoreRef = null,
  isAdmin = false,
  manager = null,
  onRefreshApps = null,
}) {
  const [selectedApp, setSelectedApp] = useState(null);

  const handleAdminCardClick = (app) => {
    setSelectedApp(app);
  };
  if (loading && apps.length === 0) {
    return (
      <div className="community-app-grid community-app-grid--loading">
        <div className="community-app-grid-loading">
          <i className="fa-solid fa-spinner fa-spin" aria-hidden />
          <p>Loading community apps...</p>
        </div>
      </div>
    );
  }

  if (!apps || apps.length === 0) {
    return (
      <div className="community-app-grid">
        <div className="community-app-grid-empty">
          <i className="fa-solid fa-cube" aria-hidden />
          <h3>No apps found</h3>
          <p>{emptyMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="community-app-grid">
        {apps.map((app) => (
          <CommunityAppCard
            key={app.id}
            app={app}
            isAdmin={isAdmin}
            onAdminCardClick={isAdmin ? handleAdminCardClick : undefined}
          />
        ))}
        {loadMoreRef && (
          <div ref={loadMoreRef} className="community-app-grid-sentinel" aria-hidden />
        )}
      </div>
      {isAdmin && (
        <CommunityAppCardModal
          app={selectedApp}
          isOpen={!!selectedApp}
          onClose={() => setSelectedApp(null)}
          manager={manager}
          onReviewSettingsUpdated={onRefreshApps}
        />
      )}
    </>
  );
}
